(function () {
  'use strict';

  var DESKTOP_MQ = '(min-width: 990px)';
  var DIR_THRESHOLD_PX = 48;
  var FALLBACK_TITLES = { 1: 'STARTUP', 2: 'EXPANZE', 3: 'IMPÉRIUM' };
  var ARROW_STOPS = {
    1: ['#ff9f4a', '#ff7a1f', '#ffb020', '#ffe066'],
    2: ['#e879f9', '#d058ff', '#9b8cff', '#67e8ff'],
    3: ['#67e8ff', '#3ad8ff', '#8ec5ff', '#c084fc']
  };

  var root;
  var titleEl;
  var jumpBtn;
  var desktopMq;
  var homeParent = null;
  var homeNext = null;
  var ticking = false;
  var docBound = false;
  var currentPhase = 2;
  var unlocked = false;

  function clampPhase(value) {
    var n = parseInt(value, 10);
    if (n === 1 || n === 3) return n;
    return 2;
  }

  function isDesktop() {
    if (desktopMq) return desktopMq.matches;
    return window.innerWidth >= 990;
  }

  function scrollYNow() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function introLocked() {
    return !!(document.body && document.body.classList.contains('intro-locked'));
  }

  function loadingActive() {
    var node = document.querySelector('.moje-loading-root');
    if (!node) return false;
    if (node.classList.contains('moje-loading--done') || node.classList.contains('moje-loading--disabled')) {
      return false;
    }
    return true;
  }

  function designMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function isSimpleCard() {
    return !!(root && root.classList.contains('moje-planeta--simple'));
  }

  function reachedPricing() {
    var y;
    var scene;
    if (designMode()) return true;
    scene = document.querySelector('.moje-s2b__pricing-scene--visible');
    if (scene) return true;
    if (typeof window.__mojeS2bPricingScrollY === 'function') {
      try {
        y = window.__mojeS2bPricingScrollY();
        if (isFinite(y) && y > 8 && scrollYNow() >= y - 48) return true;
      } catch (err) {}
    }
    return false;
  }

  function inDrawer() {
    return !!(root && root.closest('[data-moje-drawer-planeta-host]'));
  }

  function relocate() {
    var host = document.querySelector('[data-moje-drawer-planeta-host]');
    if (!root) return;
    if (!homeParent) {
      homeParent = root.parentNode;
      homeNext = root.nextSibling;
    }
    if (!isDesktop() && host) {
      if (root.parentNode !== host) host.appendChild(root);
      root.classList.add('moje-planeta--in-drawer');
      root.hidden = false;
      root.classList.add('is-ready');
      return;
    }
    root.classList.remove('moje-planeta--in-drawer');
    if (homeParent && root.parentNode !== homeParent) {
      if (homeNext && homeNext.parentNode === homeParent) homeParent.insertBefore(root, homeNext);
      else homeParent.appendChild(root);
    }
  }

  function canShow() {
    if (introLocked() || loadingActive()) return false;
    if (inDrawer()) return true;
    if (!isDesktop()) return false;
    if (unlocked) return true;
    if (reachedPricing()) {
      unlocked = true;
      return true;
    }
    return false;
  }

  function s2bStartY() {
    var range;
    var el;
    var rect;
    if (typeof window.__mojeS2bSequenceRangeY === 'function') {
      try {
        range = window.__mojeS2bSequenceRangeY();
        if (range && isFinite(range.start) && range.start > 8) return range.start;
      } catch (err) {}
    }
    el = document.querySelector('.moje-s2b, [id^="moje-s2b-"]');
    if (!el) return 0;
    rect = el.getBoundingClientRect();
    return rect.top + scrollYNow();
  }

  function goToS2b() {
    var y = s2bStartY();
    if (!isFinite(y) || y < 0) return;
    if (typeof window.__mojeScrollSpyGoToY === 'function') {
      window.__mojeScrollSpyGoToY(y, true, { source: 'planeta', playAutoplay: true });
      return;
    }
    try {
      document.dispatchEvent(
        new CustomEvent('moje:programmatic-scroll', {
          detail: { y: y, source: 'planeta', smooth: true, playAutoplay: true }
        })
      );
    } catch (err) {}
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  function titleFor(phase) {
    var card =
      document.querySelector('.moje-s2b [data-s3-pricing-card="' + phase + '"] h3');
    var text = card && card.textContent ? card.textContent.replace(/\s+/g, ' ').trim() : '';
    if (text) return text;
    return root.getAttribute('data-title-' + phase) || FALLBACK_TITLES[phase] || '';
  }

  function readLivePhase() {
    var active =
      document.querySelector('.moje-s2b .moje-s2b__pricing-card--active');
    var raw;
    if (!active) return currentPhase;
    raw = active.getAttribute('data-s3-pricing-card');
    return clampPhase(raw);
  }

  function applyArrowStops(phase) {
    var colors = ARROW_STOPS[phase] || ARROW_STOPS[2];
    var stops;
    var i;
    if (!root) return;
    stops = root.querySelectorAll(
      '.moje-planeta__chevron-stop-a, .moje-planeta__chevron-stop-b, .moje-planeta__chevron-stop-c, .moje-planeta__chevron-stop-d'
    );
    for (i = 0; i < stops.length && i < colors.length; i += 1) {
      stops[i].setAttribute('stop-color', colors[i]);
      stops[i].style.stopColor = colors[i];
    }
  }

  function applyPhase(phase, force) {
    var next = clampPhase(phase);
    if (!root) return;
    if (!force && next === currentPhase) {
      if (titleEl) titleEl.textContent = titleFor(next);
      applyArrowStops(next);
      return;
    }
    currentPhase = next;
    root.setAttribute('data-phase', String(next));
    if (titleEl) titleEl.textContent = titleFor(next);
    applyArrowStops(next);
  }

  function syncDirection() {
    var startY;
    var delta;
    var dir;
    if (!root) return;
    startY = s2bStartY();
    delta = startY - scrollYNow();
    if (delta > DIR_THRESHOLD_PX) dir = 'down';
    else dir = 'up';
    root.setAttribute('data-dir', dir);
    if (jumpBtn) {
      jumpBtn.setAttribute(
        'aria-label',
        dir === 'down' ? 'Přejít na začátek sekce přistání' : 'Přejít na začátek sekce přistání'
      );
    }
  }

  function updateVisibility() {
    var show;
    if (!root) return;
    relocate();
    show = canShow();
    if (inDrawer()) {
      root.hidden = false;
      root.classList.add('is-ready');
      return;
    }
    root.hidden = !show;
    root.classList.toggle('is-ready', show);
  }

  function update() {
    updateVisibility();
    if (!canShow()) return;
    applyPhase(readLivePhase(), false);
    syncDirection();
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      update();
    });
  }

  function onPlanChanged(event) {
    var plan = event && event.detail ? event.detail.plan : null;
    applyPhase(plan, true);
    requestUpdate();
  }

  function onJump(event) {
    event.preventDefault();
    if (isSimpleCard()) return;
    goToS2b();
  }

  function bind() {
    if (jumpBtn && !isSimpleCard()) {
      if (typeof window.mojeBindTap === 'function') {
        window.mojeBindTap(jumpBtn, onJump);
      } else {
        jumpBtn.addEventListener('click', onJump);
      }
    }
    if (docBound) return;
    docBound = true;
    document.addEventListener('pricingPlanChanged', onPlanChanged);
    document.addEventListener('moje:s2b-default-ready', requestUpdate);
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('load', requestUpdate);
    document.addEventListener('moje:page-reveal', requestUpdate);
    document.addEventListener('shopify:section:load', requestUpdate);
    if (desktopMq && desktopMq.addEventListener) {
      desktopMq.addEventListener('change', requestUpdate);
    }
    if (typeof MutationObserver === 'function' && document.body) {
      new MutationObserver(requestUpdate).observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
      var pricingRoot = document.querySelector('.moje-s2b');
      if (pricingRoot) {
        new MutationObserver(function () {
          applyPhase(readLivePhase(), false);
          requestUpdate();
        }).observe(pricingRoot, {
          attributes: true,
          subtree: true,
          attributeFilter: ['class']
        });
      }
    }
  }

  function boot() {
    root = document.querySelector('[data-moje-planeta]');
    if (!root || root.dataset.mojePlanetaInit === '1') return;
    root.dataset.mojePlanetaInit = '1';
    titleEl = root.querySelector('[data-moje-planeta-title]');
    jumpBtn = root.querySelector('[data-moje-planeta-jump]');
    desktopMq = window.matchMedia ? window.matchMedia(DESKTOP_MQ) : null;
    currentPhase = clampPhase(root.getAttribute('data-phase'));
    document.documentElement.style.removeProperty('--moje-planeta-reserve');
    bind();
    applyPhase(readLivePhase(), true);
    update();
    window.setTimeout(requestUpdate, 400);
    window.setTimeout(requestUpdate, 1400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
